import { useState, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { HiFilter } from 'react-icons/hi'
import { FaTrophy } from 'react-icons/fa'
import SEO from '../../components/SEO/SEO'
import { seoBreadcrumbPair } from '../../utils/seoUtils'
import './RecordBook.css'

function RecordBook() {
  const { t, i18n } = useTranslation()
  const [selectedDiscipline, setSelectedDiscipline] = useState('all')
  
  const isJapanese = i18n.language === 'ja'
  const isRussian = i18n.language === 'ru'

  const getDisciplineName = (id) => {
    const names = {
      kubo: { ru: 'КУБО', en: 'KUBO', ja: 'КУБО' },
      aikido: { ru: 'Айкидо', en: 'Aikido', ja: '合気道' },
      aikijutsu: { ru: 'Айки-дзюцу', en: 'Aiki-jutsu', ja: '合気術' },
      jujutsu: { ru: 'Дзю-дзюцу', en: 'Jujutsu', ja: '柔術' },
      aikibujutsu: { ru: 'Айки-бу-дзюцу', en: 'Aiki-bu-jutsu', ja: '合気武術' },
      karatejutsu: { ru: 'Карате-дзюцу', en: 'Karate-jutsu', ja: '空手術' },
      kenjutsu: { ru: 'Кэн-дзюцу', en: 'Kenjutsu', ja: '剣術' },
      kempo: { ru: 'Кемпо', en: 'Kempo', ja: '拳法' }
    }
    const lang = isJapanese ? 'ja' : (isRussian ? 'ru' : 'en')
    return names[id] ? names[id][lang] : id
  }

  const breadcrumbItems = useMemo(
    () => seoBreadcrumbPair(t('common.home'), t('common.recordBook'), 'record-book'),
    [t]
  )

  // Mock data
  const records = []

  return (
    <div className="record-book-page">
      <SEO 
        title={t('common.recordBook')}
        description={t('recordBook.description', 'Record Book of SUMA International')}
        breadcrumbItems={breadcrumbItems}
      />
      <div className="container">
        <div className="record-book-hero">
          <FaTrophy className="hero-icon" />
          <h1>{t('common.recordBook')}</h1>
          <p className="record-book-intro">
            {t('recordBook.intro', 'The Record Book documents outstanding achievements, records, and milestones in SUMA International competitions and events.')}
          </p>
        </div>

        <div className="records-filter">
          <HiFilter className="filter-icon" />
          <select
            value={selectedDiscipline}
            onChange={(e) => setSelectedDiscipline(e.target.value)}
            className="discipline-select"
          >
            <option value="all">{t('recordBook.all', 'All Disciplines')}</option>
            <option value="kubo">{getDisciplineName('kubo')}</option>
            <option value="aikido">{getDisciplineName('aikido')}</option>
            <option value="aikijutsu">{getDisciplineName('aikijutsu')}</option>
            <option value="jujutsu">{getDisciplineName('jujutsu')}</option>
            <option value="aikibujutsu">{getDisciplineName('aikibujutsu')}</option>
            <option value="karatejutsu">{getDisciplineName('karatejutsu')}</option>
            <option value="kenjutsu">{getDisciplineName('kenjutsu')}</option>
            <option value="kempo">{getDisciplineName('kempo')}</option>
          </select>
        </div>

        <div className="records-list">
          {records.length > 0 ? (
            records.map(record => (
              <div key={record.id} className="record-card">
                <FaTrophy className="record-icon" />
                <div className="record-info">
                  <h3>{record.title}</h3>
                  <p className="record-holder">{record.holder}</p>
                  <p className="record-discipline">{record.discipline ? getDisciplineName(record.discipline) : ''}</p>
                  <p className="record-date">{record.date}</p>
                </div>
              </div>
            ))
          ) : (
            <div className="no-records">
              <p>{t('recordBook.noRecords', 'Records will be displayed here as they are established and documented.')}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default RecordBook
